export default "__VITE_ASSET__DHqxNwp9__"